/**
 * As opções de recurso de um `<select>`, garantindo que o valor GRAVADO apareça.
 *
 * A referência a recurso é por NOME, não por FK (ver o docstring de `apps/seop/models.py`),
 * e a tela deixa excluir um recurso que ainda está em rota ou em parâmetro de lote — o
 * modal só avisa quantos. Depois disso o campo controlado ficaria em branco, e o
 * salvamento seguinte trocaria o recurso sem ninguém pedir. Mostrar o órfão marcado é o
 * que mantém a tela dizendo a verdade sobre o que está no banco.
 */
export function opcoesDeRecurso(nomes: string[], atual: string): { valor: string; rotulo: string }[] {
  const opcoes = nomes.map((n) => ({ valor: n, rotulo: n }));
  if (atual && !nomes.includes(atual)) {
    opcoes.unshift({ valor: atual, rotulo: `${atual} (fora do cadastro)` });
  }
  return opcoes;
}
